/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactModel } from '../../models/client-survey-contact-model';

export interface GetSurveyContactAsync$Plain$Params {

/**
 * id of the client rep in AD. optional
 */
  repId?: number;

/**
 * surveytype id filter
 */
  surveyTypeId: number;

/**
 * case id filter
 */
  caseId: number;

/**
 * year filter
 */
  year: number;

/**
 * month filter
 */
  month: number;
}

export function getSurveyContactAsync$Plain(http: HttpClient, rootUrl: string, params: GetSurveyContactAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyContactModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyContactAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('repId', params.repId, {});
    rb.query('surveyTypeId', params.surveyTypeId, {});
    rb.query('caseId', params.caseId, {});
    rb.query('year', params.year, {});
    rb.query('month', params.month, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyContactModel>;
    })
  );
}

getSurveyContactAsync$Plain.PATH = '/api/SurveyContact';
